import { db } from '../lib/database';

export const questionResponseService = {
  storeFormQuestions(form) {
    const sections = form.sections || [];
    const questions = sections.flatMap(s => (s.fields || []).map(f => ({ ...f, section_id: s.id, section_name: s.name, section_order: s.order })));

    const questionRecords = questions.map(q => {
      const normalizedOptions = Array.isArray(q.options) ? q.options.map(opt => ({ label: opt.label || opt.value, value: opt.value })) : [];

      return {
        id: q.id,
        form_id: String(form.id),
        section_id: q.section_id,
        section_name: q.section_name,
        section_order: q.section_order,
        name: q.name,
        label: q.label || null,
        placeholder: q.placeholder || '',
        type: q.type,
        order: q.order || 0,
        options: JSON.stringify(normalizedOptions),
        is_required: !!q.is_required,
        help_text: q.description || null
      };
    });

    return db
      .transaction('rw', db.form_questions, () => {
        return db.form_questions
          .where('form_id')
          .equals(String(form.id))
          .delete()
          .then(() => db.form_questions.bulkPut(questionRecords));
      })
      .catch(error => {
        console.error(`storeFormQuestions: Failed to update questions for form ${form.id}:`, error);
      });
  },

  storeFormResponses(submission) {
    if (!submission || !submission.answers || submission.syncStatus === 'synced') {
      return Promise.resolve();
    }

    const responseRecords = Object.entries(submission.answers).map(([questionId, value]) => ({
      id: `${submission.id}-${questionId}`,
      submission_id: submission.id,
      question_id: questionId,
      value: typeof value === 'object' ? JSON.stringify(value) : value
    }));

    if (responseRecords.length > 0) {
      return db.form_responses.bulkPut(responseRecords);
    }
    return Promise.resolve();
  },

  processFormSubmission(submission) {
    if (submission.syncStatus !== 'synced' && submission?.answers) {
      const responseRecords = submission.answers.map(answer => ({
        id: `${submission.id}-${answer.form_field_id}`,
        submission_id: submission.id,
        question_id: answer.form_field_id,
        value: answer.value_JSON || answer.value_json || answer.value
      }));
      if (responseRecords.length > 0) {
        return db.form_responses.bulkPut(responseRecords);
      }
    }
    return Promise.resolve();
  },

  deleteSubmissionResponses(submissionId) {
    return db.form_responses.where('submission_id').equals(submissionId).delete();
  },

  clearAllFormQuestions() {
    return db.form_questions.clear();
  }
};
